import { render } from "./filtersearch.vue?vue&type=template&id=2023f1c2"
import script from "./filtersearch.vue?vue&type=script&lang=js"
export * from "./filtersearch.vue?vue&type=script&lang=js"

import exportComponent from "/home/metabrain/withyou/djvue/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__